const generateHourOptions = (type = 'start') => {
  const lengthHour = type === 'end' ? 13 : 12;

  return Array.from({ length: lengthHour }, (_, index) => {
    const hour = (index * 2).toString().padStart(2, '0');
    const timeString = `${hour}:00`;
    return {
      value: timeString,
      label: timeString,
    };
  });
};

const startHourOptions = () => {
  const hourOptions = [0, 8, 16];
  return hourOptions.map((hour) => ({
    value: `${hour.toString().padStart(2, '0')}:00`,
    label: `${hour.toString().padStart(2, '0')}:00`,
  }));
};

const liveHourOptions = () => {
  const hourOptions = [8, 16, 24];
  return hourOptions.map((hour) => ({
    value: hour.toString(),
    label: `${hour} Jam/Hari`,
  }));
};

export { generateHourOptions, startHourOptions, liveHourOptions };
